    // Initialize Firebase
export default {
    apiKey: "AIzaSyDS4-2-0xw5rRoZY2VbbARHOFsyOLwyAI0",
    authDomain: "merching-d1890.firebaseapp.com",
    databaseURL: "https://merching-d1890.firebaseio.com",
    projectId: "merching-d1890",
    storageBucket: "merching-d1890.appspot.com",
    messagingSenderId: "875150109419"
};



// WEBPACK FOOTER //
// ./src/firebase/fire.js